// Object type registry — the admin UI walks these in the sidebar. Mirrors
// migration 0003_seed_dev. Custom objects will be added dynamically once the
// schema endpoint exists in M-schemas.

export interface ObjectTypeMeta {
  id: string;
  label: string;
  label_plural: string;
  primary_display: string;
  display_fields: string[]; // shown in list view
  icon: string; // lucide-ish single-glyph; rendered via a tiny mapping
}

export const STANDARD_OBJECT_TYPES: ObjectTypeMeta[] = [
  {
    id: '0-1',
    label: 'Contact',
    label_plural: 'Contacts',
    primary_display: 'email',
    display_fields: ['email', 'first_name', 'last_name', 'lifecycle_stage', 'phone'],
    icon: '👤',
  },
  {
    id: '0-2',
    label: 'Company',
    label_plural: 'Companies',
    primary_display: 'name',
    display_fields: ['name', 'domain'],
    icon: '🏢',
  },
  {
    id: '0-3',
    label: 'Deal',
    label_plural: 'Deals',
    primary_display: 'dealname',
    display_fields: ['dealname', 'amount', 'dealstage'],
    icon: '💰',
  },
  {
    id: '0-5',
    label: 'Ticket',
    label_plural: 'Tickets',
    primary_display: 'subject',
    display_fields: ['subject', 'hs_pipeline_stage', 'priority'],
    icon: '🎫',
  },
];

export function findObjectType(id: string): ObjectTypeMeta | undefined {
  return STANDARD_OBJECT_TYPES.find((t) => t.id === id);
}
